// The variant picker in a product page's buy column. It owns almost nothing:
// which variant is live and what happens when it changes are the product form's
// business, and this only hands the shared picker components the list to draw
// and passes a click back to the form.

const initApexVariantPicker = ($el) => {
  const payload = utils.JSONParse(
    $el.querySelector("[data-apex-variant-picker-data]")?.innerHTML
  ) ?? { kind: null, label: "", items: [] };

  const getPickerVariants = () => payload.items;

  // A product page prints its figures whole, the way the price above the cards
  // does. The builder's rail is the one that drops a trailing .00, and the two
  // sit on different pages, so neither has to follow the other.
  const money = (cents) => utils.formatMoney(cents);

  return {
    variant_picker: payload,
    money,
    getPickerVariants,
  };
};

window._sections = window._sections || {};
window._sections["initApexVariantPicker"] = initApexVariantPicker;
